export class Piece {
    id: number;
    name: string;
    exchangeOdometer: string;
    active: boolean
}